<app-navbar></app-navbar>
<router-outlet></router-outlet>
<!-- <div class="fb-customerchat" entry_point_label="chat" entry_point_icon="chat_round_icon" page_id="100432832106831"></div> -->
<app-footer></app-footer>
<button #chatContainer
    class="chat-button" 
    matSuffix 
    mat-fab
    (click)="onChangeChatState()">
    <img alt="cdiwork_bot" [src]="iconSrc" [@rotateAnimation]="iconState" [ngClass]="isOpen ? 'button-icon chat' : 'button-icon bot'"> 
</button>
<app-chat #chatContainer *ngIf="isOpen" [@fadeAnimation]></app-chat>